import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { SiteForm } from 'app/_models/site-forms/site-form.model';
import { SiteFormsService } from 'app/_services/site-forms.service';
import Swal from 'sweetalert2';
import { SiteFormsLinkSitesModalComponent } from '../components/site-forms-link-sites-modal/site-forms-link-sites-modal.component';

@Component({
  selector: 'site-forms-details',
  templateUrl: './site-forms-details.component.html',
})
export class SiteFormsDetailsComponent implements OnInit {
  public routeRole: any;
  public siteFormId: any;
  public siteForm: SiteForm;

  public columnOptionsSidebarVisible: boolean;

  // table options
  public tableOptions = {
    visibleColumns: [],
  }

  public togglableColumns = [
    { displayName: 'Site', default: true },
    { displayName: 'Asset', default: true },
    { displayName: 'Work Order', default: true },
    { displayName: 'Date Completed', default: true },
    { displayName: 'Version', default: true },
  ];
  isLoading: boolean;

  constructor(
    private siteFormService: SiteFormsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;

    this.activatedRoute.params.subscribe((params: Params) => {
      this.siteFormId = params.id;
    });
  }

  ngOnInit() {
    this.setupColumnOptions();
    this.setupPage();
  }

  public setupPage() {
    this.isLoading = true;

    this.siteFormService.getSiteForm(this.siteFormId).subscribe(response => {
      this.siteForm = response;
      this.isLoading = false;
    });
  }

  public resetColumnOptions() {
    this.tableOptions = {
      visibleColumns: this.togglableColumns.filter(col => col.default).map(col => col.displayName),
    };

    this.saveTableOptions();
  }

  public saveTableOptions() {
    localStorage.setItem('ui.options.siteFormsDetailsTable', JSON.stringify(this.tableOptions));
  }

  private setupColumnOptions() {
    const savedOptions = localStorage.getItem('ui.options.siteFormsDetailsTable');

    if (savedOptions) {
      this.tableOptions = JSON.parse(savedOptions);
      this.togglableColumns
        .filter(col => col.default && !this.tableOptions.visibleColumns.includes(col.displayName))
        .forEach(col => this.tableOptions.visibleColumns.push(col.displayName));
      this.saveTableOptions();
    } else {
      this.resetColumnOptions();
    }
  }

  public editLinkedSites() {
    const modalOptions: NgbModalOptions = { centered: true };
    const modal = this.modalService.open(SiteFormsLinkSitesModalComponent, modalOptions);
    modal.componentInstance.siteForm = this.siteForm;

    modal.result.then(result => {
      if (result === 'refresh') {
        this.setupPage();
      }
    }).catch(() => { /* modal dismissed */ });
  }

  public deleteForm() {
    Swal.fire({
      title: 'Delete Form?',
      text: 'You will not be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.siteFormService.deleteForm(this.siteFormId).subscribe((data: any) => {
          this.router.navigate(['/', this.routeRole, 'site-forms']);
          Swal.fire(
            'Deleted!',
            'Form has been removed.',
            'success'
          )
        });
      }
    });
  }
}
